import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useTamagotchis = params => {
  const [topics, setTopics] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/playerxp`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        setTopics(response.data);
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
    }
  }, []);

  return topics ;
};

export default useTamagotchis;
